export default {
	er_cover_default_title: 'Prestatieoverzicht',
	er_page_success_metrics: 'Wat er deze maand veranderde',
	er_page_success_metrics_range: 'Wat er in deze periode veranderde',
	er_page_success_metrics_week: 'Wat er deze week veranderde',
	er_page_comparison: 'Vergelijkingssamenvatting',
	er_page_period_summary: 'Maandsamenvatting',
	er_page_period_summary_range: 'Periodesamenvatting',
	er_page_period_summary_week: 'Weeksamenvatting',
	er_page_each_month: 'Elke maand',
	er_page_rooms: 'Ruimtes',
	er_rooms_note: 'Elke ruimte in {month}, hoogste score eerst.',
	er_page_shift_comparison: 'Vergelijking per dienst',
	er_page_shift_summary: 'Per dienst',
	er_page_response_time: 'Gemiddelde reactietijd (min)',
	er_page_avg_score: 'Ervaringsscore',
	er_page_complaints_vs_visits: 'Klachten vs bezoeken',
	er_page_performance_trends: 'Prestatietrends',
	er_page_complaint_drivers: 'Klachtoorzaken',

	er_board_working: 'Verbeterd t.o.v. {month}',
	er_board_attention: 'Vraagt aandacht t.o.v. {month}',
	er_board_empty: 'Geen noemenswaardige wijzigingen deze maand.',
	er_board_empty_range: 'Geen noemenswaardige wijzigingen in deze periode.',
	er_board_empty_week: 'Geen noemenswaardige wijzigingen deze week.',
	er_findings_intro: 'Vergeleken met {month}. Alleen noemenswaardige wijzigingen worden getoond.',
	er_verdict_improved: 'Verbeterd',
	er_verdict_watch: 'Vraagt aandacht',

	er_col_metric: 'Indicator',
	er_col_avg: 'Gem. YTD',
	er_col_lifetime_avg: 'Gem. sinds start',
	er_comparison_note: 'Gem. YTD is het cijfer van januari t/m {month}.',
	er_lifetime_note: 'Sinds start is het maandgemiddelde vanaf de eerste dag met gegevens tot en met {month}.',
	er_comparison_note_week: 'De rapportweek wordt vergeleken met de geselecteerde vorige week.',
	er_period_only_note: 'De cijfers gelden alleen voor {month}.',
	er_each_month_note: 'Elke maand in de gekozen periode. Een maand zonder gegevens blijft leeg.',
	er_col_inc_dec: 'Wijz.',
	er_col_complaint: 'Klacht',
	er_col_qty: 'Aantal',
	er_total: 'Totaal',

	er_metric_avg_score: 'Ervaringsscore',
	er_metric_avg_response_time: 'Gemiddelde reactietijd',
	er_metric_cleaner_arrivals: 'Aankomsten schoonmakers',
	er_metric_supervisor_inspections: 'Inspecties supervisors',
	er_metric_complaints_vs_visits_pct: 'Klachten vs. bezoeken (%)',
	er_metric_complaints: 'Klachten',
	er_metric_customer_visits: 'Bezoeken',
	er_metric_expired_slas: 'Verlopen SLA\'s',
	er_unit_min: 'min',
	er_stat_expected_sla: 'Verwachte SLA',
	er_stat_vs_minutes: 'vs {value} in {month}',
	er_stat_vs_count: 'vs {value} in {month}',
	er_label_complaints: 'Klachten',
	er_label_visits: 'Bezoeken',
	er_label_complaints_per_visits: 'Klachten / bezoeken',
	er_chart_ratio: 'Klachten-bezoekverhouding',
	er_chart_ytd_window: 'Januari t/m {month}.',
	er_cv_formula: 'Klachten gedeeld door toiletbezoeken, als percentage: ({complaints} ÷ {visits}) × 100 = {ratio}% in {month}.',
	er_export_kpis_title: 'Wat het rapport bevat',
	er_export_kpis_desc: 'Dit zit allemaal in het rapport. Zet er een uit om die weg te laten.',
	er_export_select_all: 'Alles selecteren',
	er_export_clear_all: 'Alles wissen',
	er_export_summary: '{report} vs {compare}',
	er_export_period_title: 'Rapportperiode',
	er_export_grain: 'Rapport per',
	er_export_grain_month: 'Maand',
	er_export_grain_week: 'Week',
	er_export_week_starts: 'Week begint op',
	er_export_week_starts_sunday: 'zondag',
	er_export_week_starts_monday: 'maandag',
	er_export_report_month: 'Rapportmaand',
	er_export_from_month: 'Van',
	er_export_to_month: 'Tot',
	er_export_period_note_range: 'Het rapport telt elke maand van begin tot eind op. Met vergelijking aan wordt de vorige periode van dezelfde lengte gebruikt. Jaar-tot-nu cijfers lopen nog steeds van januari tot en met de eindmaand.',
	er_export_summary_range: '{from} – {to}',
	er_export_summary_range_vs: '{from} – {to} vs {compare}',
	er_export_compare_range_note: 'De vorige periode van dezelfde lengte.',
	er_export_report_week: 'Rapportweek',
	er_export_compare_month: 'Vergelijken met',
	er_export_shift: 'Dienst',
	er_export_shift_all: 'Alle diensten',
	er_export_no_shifts: 'Deze locatie heeft geen actieve diensten.',
	er_export_render_failed: 'Het rapport kon niet correct worden opgebouwd en is daarom niet gedownload. Vernieuw de pagina en probeer het opnieuw.',
	er_export_comparison: 'Vergelijking',
	er_export_include_previous: 'Vorige periode meenemen',
	er_export_comparison_on: 'Aan',
	er_export_comparison_off: 'Uit',
	er_export_no_previous_data: 'Er zijn geen gegevens van vóór deze periode, dus er valt niets te vergelijken.',
	er_export_compare_previous: 'Vorige maand',
	er_export_compare_previous_week: 'Vorige week',
	er_export_compare_last_year: 'Dezelfde maand vorig jaar',
	er_export_no_periods: 'Deze locatie heeft minstens één maand gegevens nodig voordat een rapport kan worden geëxporteerd.',
	er_export_no_periods_week: 'Deze locatie heeft minstens één week gegevens nodig voordat een rapport kan worden geëxporteerd.',
	er_export_period_note: 'Alleen maanden met gegevens worden getoond. Cijfers vanaf jaarbegin lopen altijd van januari tot en met de rapportmaand.',
	er_export_period_note_week: 'Alleen weken met gegevens worden getoond. De vergelijking is altijd met een eerdere week.',
	er_export_period_note_single_week: 'Alleen weken met gegevens worden getoond.',

	er_find_response_time_title: 'Gemiddelde reactietijd',
	er_find_response_time_change:
		'Veranderde van {previous} naar {current} minuten ({change}).',
	er_find_avg_score_title: 'Ervaringsscore',
	er_find_score_eased: 'Daalde van {previous} naar {current}.',
	er_find_score_improved: 'Steeg van {previous} naar {current}.',
	er_find_score_ytd_inline: 'Gelijk aan het jaargemiddelde van {ytd}.',
	er_find_score_ytd_inline_range: 'Gelijk aan het gemiddelde van januari t/m {endMonth} ({ytd}).',
	er_find_score_ytd_against: 'Jaargemiddelde: {ytd}.',
	er_find_score_ytd_against_range: 'Gemiddelde van januari t/m {endMonth}: {ytd}.',
	er_find_complaints_ratio_title: 'Klachten-bezoekverhouding',
	er_find_complaints_ratio_improved: 'Verbeterde van {previous} naar {current}.',
	er_find_complaints_ratio_rose: 'Veranderde van {previous} naar {current}.',

	er_nar_cv_year_improved:
		'Klachten ten opzichte van toiletbezoeken verbeterden van {from} naar {to} over het jaar.',
	er_nar_cv_year_rose: 'Klachten ten opzichte van toiletbezoeken stegen van {from} naar {to} over het jaar.',
	er_nar_cv_moved: 'Klachten ten opzichte van toiletbezoeken gingen van {previous} naar {current}.',
	er_nar_cv_current: 'Klachten ten opzichte van toiletbezoeken staan op {current}.',
	er_nar_types_total: 'Totaal klachten {total}.',
	er_nar_types_1: 'Belangrijkste klacht: {a} ({ap}%).',
	er_nar_types_2: 'Belangrijkste klacht: {a} ({ap}%), gevolgd door {b} ({bp}%).',
	er_nar_types_3: 'Belangrijkste klacht: {a} ({ap}%), gevolgd door {b} ({bp}%) en {c} ({cp}%).',
	er_find_rooms_slowest: 'Ruimtes met de langste reactietijd deze maand: {rooms}.',
	er_find_rooms_slowest_range: 'Ruimtes met de langste reactietijd in deze periode: {rooms}.',
	er_find_rooms_slowest_week: 'Ruimtes met de langste reactietijd deze week: {rooms}.',
	er_find_rooms_lowest_score: 'Ruimtes met de laagste score deze maand: {rooms}.',
	er_find_rooms_lowest_score_range: 'Ruimtes met de laagste score in deze periode: {rooms}.',
	er_find_rooms_lowest_score_week: 'Ruimtes met de laagste score deze week: {rooms}.',

	er_find_so_what_ratio: 'Het grootste deel van de verandering kwam van {rooms}.',
	er_find_so_what_type: 'Belangrijkste klacht: {name} ({percent}%).',
	er_hot_slowest: 'Ruimtes met de langste reactietijd',
	er_hot_expired_slas: 'Ruimtes die de SLA hebben overschreden',
	er_hot_ratio: 'Ruimtes met de grootste verandering in het klachtenpercentage',
	er_hot_top_type: 'Ruimtes met de meeste "{name}"-klachten',
	er_hot_col_room: 'Ruimte',
	er_col_response: 'Reactie',
	er_col_cleaners: 'Schoonmakers',
	er_col_score: 'Score',
	er_chart_sla: 'SLA',
	er_hot_col_ratio: 'Ratio',
	er_hot_col_change: 'Wijziging',
	er_hot_col_count: 'Aantal',
	er_hot_empty: 'Geen highlights op ruimteniveau deze maand.',
	er_hot_empty_range: 'Geen highlights op ruimteniveau in deze periode.',
	er_hot_empty_week: 'Geen highlights op ruimteniveau deze week.',
	er_cover_highlights: 'Deze maand',
	er_cover_highlights_range: 'Deze periode',
	er_cover_highlights_week: 'Deze week',
	er_cover_score_rose: 'De ervaringsscore steeg.',
	er_cover_score_eased: 'De ervaringsscore daalde.',
	er_cover_response_improved: 'De reactietijd verbeterde.',
	er_cover_response_slowed: 'De reactietijd liep op.',
	er_cover_ratio_fell: 'Klachten ten opzichte van bezoeken daalden.',
	er_cover_ratio_rose: 'Klachten ten opzichte van bezoeken stegen.',
	er_export_pdf: 'Dashboard-PDF',
	er_export_executive: 'Directieverslag',
	'executive-report': 'Directieverslag',
	er_export_csv: 'CSV',
	er_export_status_title: 'Rapport wordt gemaakt',
	er_export_status_fetch: 'Cijfers laden',
	er_export_status_layout: "Pagina's opmaken",
	er_export_status_page: 'Pagina {page} van {total}',
	er_footer_copyright: 'Dit rapport is gegenereerd via het BuzzzTech-systeem.',
	er_contact_line: 'Vragen of wilt u de data verder verkennen? Neem contact op met het BuzzzTech Customer Success-team via {email} of {phone}.',
};
